import { render } from "./TagSpan.vue?vue&type=template&id=3aad5aaf&scoped=true"
import script from "./TagSpan.vue?vue&type=script&lang=js"
export * from "./TagSpan.vue?vue&type=script&lang=js"

import "./TagSpan.vue?vue&type=style&index=0&id=3aad5aaf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aad5aaf"]])

export default __exports__